<template>
  <product-preview />
</template>

<script>
import ProductPreview from './ProductPreview';
export default {
  components: {ProductPreview}
}
</script>